import { useGetAccountUsers } from '@cocoonspace/sdk-js/domains/account/account'
import { useTranslation } from 'next-i18next'

import { useTracking } from '~/providers/tracking-provider'

import { DashboardCard } from './dashboard-card'

export const DashboardMyUsers = () => {
	const { t } = useTranslation()
	const { track } = useTracking()

	const { data: accountUsersCount, isLoading } = useGetAccountUsers({
		query: {
			select: (users) =>
				users.data.filter((user) => user.status === 'enabled')?.length || 0,
		},
	})

	return (
		<DashboardCard
			isLoading={isLoading}
			title={t('cwDashboard:myUsers.title') as string}
			link={{
				label: t('cwDashboard:myUsers.linkLabel'),
				href: '/my-account/users-management',
				onClick: () => track.click('dashboard-manageUsers-link'),
			}}
			childrenClassName='text-6xl font-bold leading-none text-primary'
		>
			{accountUsersCount}
		</DashboardCard>
	)
}
